import api from './Api'

export const career = (data) => {
  return api
    .post(
      '/landingpage/registerVendor/career',
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    .then(res => {
      return Promise.resolve(res)
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

export default career
